import { Page, Content } from '@backstage/core-components';
import { Grid } from '@material-ui/core';
import { Button } from '@WESCO-International/wdp-ui-components/components/button';
import { useAddEntityForm } from '../../hooks/useAddEntityForm';
import { useEntityOptions } from '../../hooks/useEntityOptions';
import { BasicDetailsSection } from './BasicDetailsSection.tsx';
import { LinksSection } from './LinksSection.tsx';
import { ComponentRelationsSection } from './ComponentRelationSection.tsx';

export const AddEntityPage = () => {
  const {
    kind,
    changeKind,
    form,
    setField,
    setName,
    changeDomain,
    systemOptions,
    addLink,
    removeLink,
    updateLink,
    consumesSearch,
    setConsumesSearch,
    providesSearch,
    setProvidesSearch,
    isMissingRequired,
    isSaving,
    overlay,
    propose,
    MAX_LINKS,
  } = useAddEntityForm();

  const { apiStringOptions, componentDropdownOptions } = useEntityOptions();

  return (
    <Page themeId="home">
      {overlay}
      <Content>
        <div className="pageHeader">
          <h5 className="wdp-heading s-5 semibold headingLarge">Add Catalog</h5>
          <div className="headerActions" style={{ gap: 8 }}>
            <Button
              color="primary"
              onClick={propose}
              disabled={isMissingRequired || isSaving}
            >
              Propose
            </Button>
          </div>
        </div>

        <Grid container spacing={3} className="gridFullWidth">
          <Grid item xs={12}>
            <BasicDetailsSection
              kind={kind}
              form={form}
              systemOptions={systemOptions}
              onKindChange={changeKind}
              onNameChange={setName}
              onDomainChange={changeDomain}
              onFieldChange={setField}
            />

            <LinksSection
              links={form.links}
              maxLinks={MAX_LINKS}
              onAdd={addLink}
              onRemove={removeLink}
              onUpdate={updateLink}
            />

            {kind === 'Component' && (
              <ComponentRelationsSection
                consumesApis={form.consumesApis}
                providesApis={form.providesApis}
                subcomponentOf={form.subcomponentOf}
                consumesSearch={consumesSearch}
                providesSearch={providesSearch}
                apiStringOptions={apiStringOptions}
                componentDropdownOptions={componentDropdownOptions}
                onConsumesChange={selected =>
                  setField('consumesApis', selected)
                }
                onProvidesChange={selected =>
                  setField('providesApis', selected)
                }
                onSubcomponentChange={value =>
                  setField('subcomponentOf', value)
                }
                onConsumesSearchChange={setConsumesSearch}
                onProvidesSearchChange={setProvidesSearch}
              />
            )}
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
